import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { FormControl } from 'src/components/UI/FormControl';
import { FormErrorMessage } from 'src/components/UI/FormErrorMessage';
import { Text } from 'src/components/UI/Text';
import SelectState from 'src/components/SelectState';
import Typography from 'src/components/Typography';
import { CounselCard } from './CounselCard';
import { RegisterNumberInput } from './RegisterNumberInput';
import DoctorIcon from 'src/components/Icons/DoctorIcon';
import DoctorIconPrincipal from 'src/components/Icons/DoctorIconPrincipal';
import ToothIcon from 'src/components/Icons/ToothIcon';
import ToothIconPrimary from 'src/components/Icons/ToothIconPrimary';

interface ProfessionalDataFieldsProps {
  counsel: 'CRM' | 'CRO';
  ufRegister: string;
  registerNumber: string;
  counselError?: string;
  ufRegisterError?: string;
  registerNumberError?: string;
  onCounselChange: (counsel: 'CRM' | 'CRO') => void;
  onUfRegisterChange: (value: string) => void;
  onRegisterNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onUfRegisterBlur: () => void;
  onRegisterNumberBlur?: () => void;
  isRegisterNumberLoading?: boolean;
  onShowHelp?: () => void;
}

export function ProfessionalDataFields({
  counsel,
  ufRegister,
  registerNumber,
  counselError,
  ufRegisterError,
  registerNumberError,
  onCounselChange,
  onUfRegisterChange,
  onRegisterNumberChange,
  onUfRegisterBlur,
  onRegisterNumberBlur,
  isRegisterNumberLoading = false,
  onShowHelp,
}: ProfessionalDataFieldsProps) {
  return (
    <>
      <Flex mb="20px" mt="30px" align="center" gap="8px">
        <Typography model="body" size="large" weight="bold">
          Dados profissionais
        </Typography>
      </Flex>

      <FormControl isInvalid={!!counselError} mb="20px">
        <Text mb="10px" textTransform="uppercase" fontSize="10px" fontWeight="bold">
          Conselho profissional*
        </Text>
        <Flex gap="15px">
          <CounselCard
            isSelected={counsel === 'CRM'}
            onClick={() => onCounselChange('CRM')}
            icon={
              counsel === 'CRM' ? (
                <DoctorIconPrincipal variantColor="white" width={20} />
              ) : (
                <DoctorIcon variantColor="primary.1000" width={20} />
              )
            }
            label="Medicina"
          />
          <CounselCard
            isSelected={counsel === 'CRO'}
            onClick={() => onCounselChange('CRO')}
            icon={counsel === 'CRO' ? <ToothIconPrimary width={20} /> : <ToothIcon width={20} />}
            label="Odontologia"
          />
        </Flex>
        <FormErrorMessage>{counselError}</FormErrorMessage>
      </FormControl>

      <Flex gap="15px" mb="20px">
        <FormControl w="40%" isInvalid={!!ufRegisterError}>
          <SelectState
            label="UF do registro*"
            placeholder="Selecione"
            value={ufRegister}
            onChange={onUfRegisterChange}
            onBlur={onUfRegisterBlur}
            errorMessage={ufRegisterError}
          />
        </FormControl>

        <Box flex={1}>
          <Text mb="10px" textTransform="uppercase" fontSize="10px" fontWeight="bold">
            N° do registro*
          </Text>
          <RegisterNumberInput
            counsel={counsel}
            ufRegister={ufRegister}
            value={registerNumber}
            onChange={onRegisterNumberChange}
            onBlur={onRegisterNumberBlur}
            error={registerNumberError}
            isLoading={isRegisterNumberLoading}
            onShowHelp={onShowHelp}
          />
        </Box>
      </Flex>
    </>
  );
}
